export const environment = {
      production: false,
  dashboard_url: 'https://trendy-staging-api.vmsgo.com/api/dashboard',
  merchant_url: 'https://trendy-staging-api.vmsgo.com/api/merchant',
}
